import { Theme } from '@mui/material/styles'

export const getStyles = (theme: Theme) => ({
  icon: {
    marginRight: theme.spacing(1),
    width: '18px',
    height: '17px',
  },
  formButton: { marginRight: theme.spacing(1) },
})

export const getButtonStyles = (theme: Theme) => ({
  root: {
    padding: theme.spacing(1),
    fontSize: '12px',
  },
  label: {
    whiteSpace: 'nowrap',
  },
  outlined: {
    backgroundColor: theme.palette.common.white,
  },
})
